const transitionLength = 250;

export function _getPanelHeight (panel) {
  //  set auto height and read offsetHeight
  panel.style.height = 'auto';
  let height = panel.offsetHeight;
  //  remove style
  panel.style.height = '';
  return height;
}

export function _setPanelHeight (panel) {
  //  get panel height
  let panelHeight = _getPanelHeight(panel);
  //  recalc style and layout
  panel.getBoundingClientRect();
  //  set height on panel, reset to 'auto' on transition complete
  panel.style.height = panelHeight + 'px';
  setTimeout(() => {
    panel.style.transition = 'none';
    panel.style.height = 'auto'
    //  recalc style and layout
    panel.getBoundingClientRect();
    panel.style.transition = '';
  }, transitionLength);
}

export function _unsetPanelHeight (panel) {
  //  get panel height
  let panelHeight = _getPanelHeight(panel);
  //  set panel height from 'auto' to px
  panel.style.height = panelHeight + 'px';
  //  recalc style and layout
  panel.getBoundingClientRect();
  //  reset height
  panel.style.height = 0;
}

export function isElementInViewport(el) {
  if (!el) return true;
  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= document.documentElement.clientHeight &&
    rect.right <= document.documentElement.clientWidth
    );
}



//////////////////
// WEBPACK FOOTER
// ./src/js/utils.js
// module id = 4
// module chunks = 0